"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComposeEmailDialogContainer = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_structures_1 = require("@tableau/data-structures");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const useText_1 = require("../../hooks/useText");
const useToggle_1 = require("../../hooks/useToggle");
const ComposeEmailDialogContent_1 = require("./ComposeEmailDialogContent");
const ComposeEmailDialogStyles_1 = require("./ComposeEmailDialogStyles");
function ComposeEmailDialogContainer(props) {
    const [isSubmitting, toggleIsSubmitting] = (0, useToggle_1.useToggle)();
    const subjectText = (0, useText_1.useText)('', ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.MAXIMUM_SUBJECT_LENGTH);
    const bodyText = (0, useText_1.useText)('', ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.MAXIMUM_BODY_LENGTH);
    const handleBodyChange = (event) => {
        bodyText.handleTextChange(event);
    };
    const handleSubjectChange = (event) => {
        subjectText.handleTextChange(event);
    };
    const dialogProps = () => {
        return {
            title: catalog_messages_1.Messages.EmailDialogTitle(),
            dialogWidth: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.DIALOG_WIDTH,
            testId: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.TEST_ID('dialog'),
            isModal: true,
            handleGlassClick: props.dismissDialog,
            type: widgets_1.DialogType.NormalWithTitleBar,
            positioningBehavior: widgets_1.DialogPositioningBehavior.Centered,
            shouldAdjustPositionOnWindowResize: true,
            onCloseRequest: props.dismissDialog,
            showCloseButton: false,
            showFooter: true,
            footerContent: (react_1.default.createElement(ComposeEmailDialogContent_1.ComposeEmailDialogFooter, { dismissDialog: props.dismissDialog, invokeSubmit: invokeSubmit, isSubmitting: isSubmitting, isValid: bodyText.text.textValidity === 'valid' && subjectText.text.textValidity === 'valid' })),
        };
    };
    const invokeSubmit = () => {
        toggleIsSubmitting();
        props.submitResult({
            bodyText: bodyText.text.text,
            subjectText: subjectText.text.text,
        });
        props.sendDataInImpactAnalysisEmail({
            content_luid: props.contentLuid,
            content_type: props.contentType,
            dialog_session_id: props.dialogSessionId,
            user_count: (0, data_structures_1.getKeySetSize)(props.selectedUserIds),
        });
    };
    return (react_1.default.createElement(widgets_1.DialogWidget, Object.assign({}, dialogProps()),
        react_1.default.createElement(ComposeEmailDialogContent_1.ComposeEmailDialogContent, { subjectValidity: subjectText.text.textValidity, bodyValidity: bodyText.text.textValidity, selectedUserIds: props.selectedUserIds, bodyText: bodyText.text.text, subjectText: subjectText.text.text, handleBodyChange: handleBodyChange, handleSubjectChange: handleSubjectChange })));
}
exports.ComposeEmailDialogContainer = ComposeEmailDialogContainer;
//# sourceMappingURL=ComposeEmailDialogContainer.js.map